exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  float: left;\n  color: red;\n  font-weight: bold;\n}\n\n/*.ui.modal{\n  top: 40% !important;\n}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/planning/new-planning/new-planning.component.css
// module id = ../../../../../src/app/_components/planning/new-planning/new-planning.component.css
// module chunks = main